<template>

  <div class="loginContainer">
    <div class="card">
      <div class="title">Withdraw</div>
      <div class="content">
        <span v-html="formatWithdrawalFee(hintText)"></span>
      </div>
      <div class="btnBoxWithDraw">
        <div class="submit" @click="yesClick">{{okText}}</div>
        <div class="cancel" @click="noClick">{{cancelText}}</div>
      </div>
    </div>
<!--    <div class="loginContent" @click="showSelect = false">-->
<!--      <div class="title">{{ $t('lang.messageBox.confirm') }}</div>-->
<!--      <div class="body">-->
<!--        <div class="text1">{{hintText}}</div>-->
<!--        <div class="butons">-->
<!--          <div class="no-btn" @click="noClick">{{cancelText}}</div>-->
<!--          <div class="yes-btn" @click="yesClick">{{okText}}</div>-->
<!--      </div>-->
<!--        </div>-->
<!--      </div>-->
    </div>
</template>

<script>
export default {
  name: 'Confirm2',
  props: ['confirmCancel', 'confirmToDo', 'hintText', 'okText', 'cancelText'],
  data () {
    return {
    }
  },
  methods: {
    formatWithdrawalFee (message) {
      // 去掉字符串中的引号
      const cleanMessage = message.replace(/"/g, '')
      // 格式化金额部分（包含可能存在的问号）
      const formattedMessage = cleanMessage.replace(/₹\d+\?*/g, (match) => {
        return `<span class="fee-amount">${match}</span>`
      })
      console.log(formattedMessage)
      return formattedMessage
    },
    yesClick () {
      try {
        this.confirmToDo()
      } catch (e) {
      }
      this.$store.state.confirmWinShow = false
    },
    noClick () {
      try {
        this.confirmCancel()
      } catch (e) {
      }
      this.$store.state.confirmWinShow = false
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .fee-amount{
  color: #DEBC86;
  font-size: 5.277vw;
  font-weight: bold;
}
.card{
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2vw;
  align-items: center;
  width: 86.66vw;
  height: 70.27vw;
  background-color: rgb(28,29,28);
  border-radius: 4.166vw;
  border: 1px solid rgb(115,115,115);
  padding: 0 5vw;
  .title{
    color: #FFFFFF;
    font-weight: 700;
    font-size: 5.833vw;
  }
  .content{
    height: 40%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 4.722vw;
    color: #C4C4C4;
    text-align: center;
    line-height: 9vw;
  }
  .btnBoxWithDraw{
    display: flex;
    flex-direction: column;
    gap: 4vw;
    .submit{
      width: 70.197vw;
      height: 9.44vw;
      border-radius: 1.388vw;
      background: linear-gradient(to right, #EFD6AD 0%, #DAB67C 100%);
      color: #000;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 700;
    }
    .cancel{
      width: 70.197vw;
      height: 9.444vw;
      border-radius: 1.388vw;
      color: #E1C18D;
      border: 1px solid #E1C18D;
      box-sizing: border-box;
      background-color: rgb(29,29,29);
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 700;
    }
  }
}
  .loginContainer {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,.7);
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
    .loginContent {
      position: absolute;
      top: 50%;
      left: 50%;
      width: calc(100% - 50px);
      height: 100px;
      transform: translate(-50%,-50%);
      >img {
        position: absolute;
        top: -28px;
        right: -28px;
        width: 28px;
      }
      .title {
        font-size: 24px;
        line-height: 55px;
        font-weight: bold;
        color: #543200;
        text-align: center;
        background: #F6D9AA;
        border-radius: 10px 10px 0 0;
      }
      .body {
        padding: 15px 22px;
        margin-bottom: 40px;
        background: #212324;
        border-radius: 0 0 10px 10px;
        .text1 {
          font-size: 18px;
          line-height: 21px;
          color: #F6D9AA;
        }
        .butons{
          display: flex;
          justify-content:center;
        }
        .yes-btn{
          background: #F6D9AA;
          border-radius: 6px;
          line-height: 20px;
          padding: 12px 0px;
          text-align: center;
          color: #000D2E;
          font-size: 16px;
          margin: 20px 0 0 0;
          width:100px;
        }
        .no-btn{
          background: #161616;
          border-radius: 6px;
          line-height: 16px;
          padding: 12px 0px;
          text-align: center;
          color: #fff;
          font-size: 16px;
          margin: 20px 10px 0 0;
          width:100px;
          border: 1px solid #F6D9AA;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ConfirmWin/confirmWithTwoButton.vue